import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

interface MeetingLocations {
  zoom: boolean | null;
  google_meet: boolean | null;
  teams: boolean | null;
  phone_interview: boolean | null;
  hackerrank: boolean | null;
  onsite: boolean | null;
}

interface GetMeetingLocationsApiResponse {
  data: {
    locations: MeetingLocations;
  };
  errors: string[];
}

interface GetMeetingLocationsResponse {
  locations: MeetingLocations;
  errors: string[];
}

const transformMeetingLocations = (
  res: GetMeetingLocationsApiResponse
): GetMeetingLocationsResponse => {
  return {
    locations: res.data.locations,
    errors: res.errors,
  };
};

export const useGetMeetingLocationsAvailability = () => {
  const query = useQuery<GetMeetingLocationsResponse>({
    queryKey: ['meeting-locations-availability'],
    queryFn: async () => {
      const res = await http.get<GetMeetingLocationsApiResponse>(
        'ats_interviews/locations'
      );

      return transformMeetingLocations(
        res as unknown as GetMeetingLocationsApiResponse
      );
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const { data, ...rest } = query;

  const locations = data?.locations ?? null;
  const uiError = data?.errors ?? [];

  return {
    locations,
    uiError,
    ...rest,
  };
};
